export default __webpack_public_path__ + "guide--vector-tiles-standards-cw-480-5e815c86f707d5c3b1750706e6d48f9f.png";